import { useQuery } from '@hooks/reactQuery';

import { getAllAssetTypes } from '@api/assetTypes';

import { TDefaultDTOWithoutPagination } from '@interfaces/common/defaultDTO';
import { IManageAssetTypeItem } from '@interfaces/platform/manageAssetTypes';

import { refetchOptions } from '@constants/common';
import { MANAGE_ASSET_TYPES } from '@constants/queryKeys';

export const useQueryAllAssetTypes = (props: TDefaultDTOWithoutPagination) => {
	const {
		data,
		isLoading: isLoadingAssetTypes,
	} = useQuery<IManageAssetTypeItem[]>({
		queryKey: [MANAGE_ASSET_TYPES, props],
		queryFn: () => getAllAssetTypes(props),
		select: (response) => {
			return response?.length ? response.map((item) => {
				const subRows = item.subTypes?.map((subItem) => {
					return {
						...subItem,
						assetTypeName: item.assetTypeName,
						icon: item.icon,
					};
				}) || [];

				return {
					...item,
					subRows,
				};
			}) : [];
		},
		...refetchOptions,
	});

	return {
		assetTypes: data || [],
		isLoadingAssetTypes,
	};
};
